import { ContactTableFragment } from "~/__generated__/graphql"
import { Button } from "~/ui/button"

interface ContactActionsCellProps {
  contact: ContactTableFragment
  onRemove: (contact: ContactTableFragment) => void
}

export function ContactActionsCell({ contact, onRemove }: ContactActionsCellProps) {
  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation()
    onRemove(contact)
  }

  return (
    <Button variant="secondary" size="sm" className="" onClick={handleRemove}>
      Remove
    </Button>
  )
}
